var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArticle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 89,
    viewBox: "0 0 100 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14303_299626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 68.5,
    rx: 64,
    ry: 64.5,
    fill: "white",
    fillOpacity: 0.13
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.17768 53.1416C9.27354 48.1231 20.4231 43.6542 32.1488 39.7839C35.3092 38.504 38.8638 37.6165 42.6053 37.1731C46.8825 36.9721 51.1646 37.5651 54.8751 38.8722C54.8751 38.8722 55.024 38.8728 55.0663 38.9498C56.0651 39.2481 57.0425 39.5849 58.0199 39.9344C68.6431 43.8172 78.0043 49.488 81.9558 56.5981C82.6669 57.9045 83.2025 59.2427 83.5576 60.5999C84.5041 64.5219 84.0758 68.5165 82.3002 72.3261C79.8084 77.4679 75.5258 82.2273 69.7368 86.2884C62.9638 91.4275 53.8177 95.2454 43.4404 97.2653C39.3879 97.9953 35.1817 98.3759 30.9471 98.3956C18.1813 98.4491 5.27756 95.6078 -6.04826 91.8504C-8.23952 91.1422 -10.3672 90.3645 -12.4222 89.5207C-16.1968 88.0719 -19.5059 86.2237 -22.1884 84.066C-34.9122 73.0675 -14.4584 59.9038 -1.17768 53.1416Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.9929 74.6537C-16.6646 69.8236 -14.5786 57.3579 15.1379 46.1356C52.2836 32.1078 98.3688 56.1555 78.0235 76.5036C57.6781 96.8516 -25.3987 114.733 -9.9856 90.9938C5.42755 67.2544 32.0923 94.0769 13.4424 85.2902C-5.20752 76.5036 -6.28644 72.0332 19.9159 59.0844",
    stroke: "#393B46",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2617 31.5693L21.2508 16.8344C18.691 15.9147 15.861 17.3177 15.0708 19.9089L-10.149 102.982C-11.0743 106.029 -9.31827 109.238 -6.2384 110.111L31.4833 120.872C33.7932 121.529 36.2382 120.261 37.0216 118.005L63.8152 39.9538C66.8681 31.6968 62.255 31.5693 62.255 31.5693L62.2617 31.5693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8003 29.6425L24.7894 14.9076C22.2296 13.988 19.3996 15.3909 18.6094 17.9821L-6.61046 101.055C-7.53577 104.102 -5.7797 107.311 -2.69983 108.184L35.0219 118.945C37.3318 119.603 39.7767 118.334 40.5602 116.078L67.3538 38.027C70.3999 29.7902 65.7936 29.6425 65.7936 29.6425L65.8003 29.6425Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5177 37.041C29.3691 37.4303 29.153 37.7794 28.9166 38.0479C27.4105 36.1817 24.9587 36.6516 24.1617 36.8799C23.9726 36.081 23.9794 35.1949 24.3171 34.4834C24.3238 34.4498 24.3374 34.4229 24.3644 34.3961C24.5602 34.0067 24.8709 33.6912 25.2897 33.4428C27.6671 32.0734 30.3553 34.5438 30.3553 34.5438C30.3553 34.5438 30.1999 35.2621 29.5313 37.041L29.5177 37.041Z",
    fill: "#F69C29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6192 38.0873C27.7682 38.7653 26.5322 39.3494 25.6811 39.1211C25.1678 38.9869 24.6275 38.2753 24.3101 37.4026C25.1408 37.1408 26.7618 36.6642 28.6192 38.094L28.6192 38.0873Z",
    fill: "#57BEA3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6121 34.248C29.903 33.4827 28.694 32.7645 27.4174 32.5362C26.1409 32.3214 24.8239 32.8316 24.2295 33.3552C24.4186 31.7575 25.0062 29.4684 25.5871 28.7904C26.4516 27.7969 30.3082 28.6897 30.5581 29.7302C30.808 30.764 29.8759 31.9388 30.3825 32.0529C30.8891 32.167 30.7675 31.5964 31.3348 31.7239C31.8346 31.8515 31.4159 33.3082 30.6121 34.2547L30.6121 34.248Z",
    fill: "#57BEA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.398 39.8662C25.398 39.8662 24.1688 40.6181 24.6888 40.994C25.2089 41.3699 25.5196 41.8533 25.9046 41.6586C26.2896 41.4639 26.8164 39.8796 26.8164 39.8796L25.4048 39.8796L25.398 39.8662Z",
    fill: "#F69C29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6963 41.3901C23.3788 41.0343 22.9331 40.8396 22.467 40.8195C21.643 40.7993 20.5353 41.041 20.0288 42.3702C19.198 44.5787 18.9481 46.4919 19.5493 46.7201C20.1504 46.9484 24.7364 48.687 27.4853 48.0762C30.2343 47.4653 29.3765 45.3239 29.5318 43.5651C29.6872 41.8063 27.0193 41.5176 26.8167 41.7727C26.6478 42.0211 24.5811 42.3635 23.6895 41.3901L23.6963 41.3901Z",
    fill: "#ED4C2C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3445 41.9407C23.3445 41.9407 22.7569 41.3768 22.1896 41.5647C21.6222 41.7527 21.6965 42.3434 21.8451 42.6052C21.9937 42.8738 22.3111 43.2295 22.9798 43.0617C23.6485 42.8805 24.4589 42.5582 24.4589 42.5582",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7692 43.0758C25.7692 43.0758 26.6202 43.6599 27.093 43.6062C27.5658 43.5592 27.7414 43.0624 27.7076 42.9684C27.6536 42.8677 26.5392 42.4717 26.5392 42.4717C26.5392 42.4717 25.5193 42.5053 25.418 42.6059",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8841 43.4512C24.8841 43.4512 24.0736 45.1965 24.0533 45.4114C24.0533 45.6262 23.54 47.7743 23.54 47.7743",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1495 25.8899C21.1495 25.8899 15.9353 43.0751 17.097 45.1158C18.2588 47.1566 26.8567 48.9422 29.9164 47.6466C32.976 46.351 36.9406 33.2003 35.7519 30.0251C34.5564 26.8499 23.3041 24.6816 23.3041 24.6816C22.0883 24.4869 21.1495 25.8899 21.1495 25.8899Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9941 33.9385L58.3784 39.8861",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.979 38.8457L54.4197 43.236",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6162 42.4854L53.5829 47.0904",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5879 48.7549L53.5895 52.4738",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3494 58.26L13.7064 54.6484L12.9702 70.5312L46.4368 75.962L50.4825 63.7445",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.644 57.5283L38.3994 62.9457",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0293 63.5156L44.1538 66.2008",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 67.7656L38.2779 71.4175",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53271 77.3105C8.53271 77.3105 1.95421 90.5149 4.3992 93.9251C6.84419 97.342 32.2059 106.116 35.2925 101.88C38.3656 97.6373 44.1539 85.9703 40.9862 84.6814C37.8118 83.4126 13.2943 78.8612 13.2943 78.8612",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.437 83.4336L35.873 86.8773",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3765 86.5557L33.0031 93.6311",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14303_299626",
    x: -36,
    y: 0,
    width: 136,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_14303_299626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticle);
export default __webpack_public_path__ + "static/media/icon-article.284b601754474e08fb51b00e836ade97.svg";
export { ForwardRef as ReactComponent };